import { render, staticRenderFns } from "./groupF.vue?vue&type=template&id=24e8264e&scoped=true"
import script from "./groupF.vue?vue&type=script&lang=js"
export * from "./groupF.vue?vue&type=script&lang=js"
import style0 from "./groupF.vue?vue&type=style&index=0&id=24e8264e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8264e",
  null
  
)

export default component.exports